// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"tab-2025_uk-open__GAH4m","grecaptcha-badge":"tab-2025_grecaptcha-badge__2cetZ","root":"tab-2025_root__RKiXu","tabs":"tab-2025_tabs__2vypt","tab":"tab-2025_tab__nuMOF","arrow":"tab-2025_arrow__ONfsG","icon":"tab-2025_icon__bp9aB","isSelected":"tab-2025_isSelected__TWpNC","corner":"tab-2025_corner__iAoWT","cornerLeft":"tab-2025_cornerLeft__LMyQJ","cornerRight":"tab-2025_cornerRight__QEeLm"};
    if(module.hot) {
      // 1793877043737
      var cssReload = require("!../../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  